﻿const THEME_KEY = "viwo-theme";

function getSystemTheme() {
    return window.matchMedia("(prefers-color-scheme: dark)").matches
        ? "dark"
        : "light";
}

function getPreferredTheme() {
    const stored = localStorage.getItem(THEME_KEY);
    if (stored === "dark" || stored === "light") {
        return stored;
    }

    return getSystemTheme();
}

function applyTheme(theme) {
    document.documentElement.setAttribute("data-theme", theme);
}

function saveTheme(theme) {
    localStorage.setItem(THEME_KEY, theme);
}

function toggleTheme() {
    const current = document.documentElement.getAttribute("data-theme") || "light";
    const next = current === "dark" ? "light" : "dark";

    applyTheme(next);
    saveTheme(next);
}

export function initTheme() {
    const theme = getPreferredTheme();
    applyTheme(theme);

    const toggle = document.querySelector("[data-theme-toggle]");
    if (toggle) {
        toggle.addEventListener("click", toggleTheme);
    }

    const media = window.matchMedia("(prefers-color-scheme: dark)");

    const onSystemThemeChange = (e) => {
        const stored = localStorage.getItem(THEME_KEY);

        // kullanıcı manuel seçim yapmadıysa sistem değişimini takip et
        if (!stored) {
            applyTheme(e.matches ? "dark" : "light");
        }
    };

    if (typeof media.addEventListener === "function") {
        media.addEventListener("change", onSystemThemeChange);
    } else if (typeof media.addListener === "function") {
        media.addListener(onSystemThemeChange);
    }
}